export default __webpack_public_path__ + "static/media/hnh4.041e3f5b.png";